import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from './components_root/ToastContext'; // ✅ Make sure path is correct

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider> 
        <App />
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
